import { useMemo } from 'react';

import { FiltersResponse } from '../../core';

export const useBrandModelCount = (availableFilters?: FiltersResponse) => {
  return useMemo(() => {
    const map: Record<string, number> = {};
    availableFilters?.brands.forEach((brand) => {
      brand.models.forEach(({ grouped_configs_count, id: modelId }) => {
        map[`${brand.id}::${modelId}`] = grouped_configs_count ?? 1;
      });
    });

    return map;
  }, [availableFilters]);
};
